import $ from 'jquery';

class Toggler {
	constructor ( el ) {
		this.$el = $( el );
		this.target = this.$el.attr( 'data-target' );

		this.addEventListener();
	}

	addEventListener () {
		if ( ! this.target ) {
			return;
		}

		this.$el.click( e => {
			let $target = $( this.target );

			if ( $target.length > 0 ) {
				this.$el.toggleClass( 'toggler--active' );
				$target.toggleClass( 'active' );
			}
		} );
	}
}

$( '.toggler' ).each( ( index, el ) => {
	new Toggler( el );
} );
